import React, { Component, Fragment } from "react";
import { Link ,  NavLink , withRouter } from "react-router-dom";
import style from "../employer.css";
import AppContext from "../../../contexts/AppContext";
import Alart from "../Alert";
import HeaderMessages from "../../messages/HeaderMessages";
import { records as HeaderNotiRec } from "../../../services/notification";
import {list as Appcats} from "../../../services/appCategory";
import AccountNav from "./AccountNav";
import { list as pages } from "../../../services/dynamicWPLinks";

export class Header extends Component {
    state = {
        sidenav: false,
        unread: 0,
        cats: [],
    };

    componentDidMount() {
        var countDown = 0;
        setInterval(() => {
            if (countDown % 30 === 0) {
                HeaderNotiRec(this.context.state.lastNotification).then(response => {
                    this.setState({
                        unread: response.meta.unread
                    });
                });
            }
            countDown = countDown + 1;
        }, 1000);

        Appcats()
            .then(response => {
                this.setState({
                    cats: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        pages()
            .then((response) => {
                this.setState({
                    wpLibraryPages: response.data.filter(
                        (item) => item.parent_nav === "library"
                    ),
                    wpToolsPages: response.data.filter(
                        (item) => item.parent_nav === "tools"
                    ),
                });
            })
            .catch((error) => {
                this.context.state.handelError(error);
            });
    }

    toggleSideNav()
    {
        this.setState({ sidenav: this.state.sidenav === true ? false : true });
        if(this.state.sidenav == false){
            document.body.classList.add('bodyScrollHide');
        }else{
            document.body.classList.remove('bodyScrollHide');
        }
    }
    render() {
        return (
            <Fragment>
                <header className="employer-header">
                <Alart></Alart>

                <div className="header-v2">

                    <div className="container-fluid employer-container-fluid">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="flex-body header-left">
                                <a to="#" onClick={() => this.toggleSideNav()} id="side-menu-button"><i className="fe fe-menu" aria-hidden="true"></i></a>
                                <a className="brand" href="/"><img src="/images/logo_w.png" width="161" height="34" alt="logo"/></a>

                            </div>
                            <div className="dashboard-nav header-dashboard-nav employer-container">
                                <AccountNav />
                            </div>
                            {/* <div className="flex-body center">
                                <a className="brand" href="/"><img src="/images/logo_w.png" alt="logo"/></a>
                                <nav className="navbar">
                                    <ul className="nav navbar-nav">
                                        <li>
                                            <a href="/education">Education</a>
                                        </li>
                                        <li>
                                            <a href="/jobs">Jobs</a>
                                        </li>

                                        <li>
                                            <a href="/library/articles">Library</a>
                                        </li>
                                        <li>
                                            <a href="/tools/portfolios">Tools</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div> */}

                            <div className="flex-body right">
                                <div className="btn-grp auth">
                                    <a className={`link2 ${this.state.unread > 0 ? 'have-notification' : ''}`} href="/employer/notifications"><i className="fe fe-bell notificationsCounts" aria-hidden="true"></i></a>
									<HeaderMessages></HeaderMessages>
									<div className="navbar-user">
                                        <div className="dropdown">
                                            <NavLink
                                                to={`/employer/account`}
                                                id="sidebarIcon"
                                                className="dropdown-t nav-link dropdown-toggler-user link3"
                                                role="button"
                                            >
                                                <div className="avatar avatar-sm avatar-online">
                                                    <img
                                                        src={
                                                            this.context.state.user
                                                                .image
                                                        }
                                                        className="avatar-img user-avatar-img rounded-circle"
                                                        alt=""
                                                    />
                                                </div>
                                            </NavLink>

                                            <div
                                                className="dropdown-menu dropdown-menu-right hide"
                                                aria-labelledby="sidebarIcon"
                                            >
											    {/*<div className="username">
                                                    {
                                                        this.context.state.user
                                                            .first_name
                                                    }{" "}
                                                    {
                                                        this.context.state.user
                                                            .last_name
                                                    }
                                                </div>
	                                            <hr/>*/}
								                {/* <a
                                                    className="dropdown-item"
													//exact={true}
                                                    href={`/pw/${this.context.state.user.url}`}
													target="_blank"
                                                >
                                                    Portfolio <i className="fe fe-external-link"></i>
                                                </a> */}
                                                <NavLink
                                                    className="dropdown-item"
                                                    to={`/employer/account`}
													exact={true}
                                                >
                                                    Dashboard
                                                </NavLink>
												<NavLink
                                                    className="dropdown-item"
                                                    to={`/employer/settings`}
													exact={true}
                                                >
                                                    Settings
                                                </NavLink>
												<NavLink
                                                    className="dropdown-item"
                                                    to={`/employer/billing`}
                                                >
                                                    Billing
                                                </NavLink>
                                                <hr/>
                                                <NavLink
                                                    to={`/logout`}
													exact={true}
                                                    className="dropdown-item"
                                                >
                                                    Logout
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.sidenav ? (this.context.state.user.email_verified !== 'true' ? `side-menu side-menu-top open` : `side-menu open`) :(this.context.state.user.email_verified !== 'true' ? `side-menu side-menu-top`: `side-menu`)}>
                            <a href="/employer/account" className="btn btn-primary">Account</a>
                            <a href="/logout" className="btn btn-primary">Logout</a>
                            <nav className="navbar">
                                <ul className="nav navbar-nav">
								    <li><a className="link" href="/jobs/hire-writers">Hire Writers</a></li>
		                            <li>
		                        	    <a href="/education">Education</a>
                                        {this.state.cats.length >= 1 ?
                                            <ul className="navbar-sub-nav d-flex align-items-center justify-content-center">

                                                {this.state.cats.map(
                                                    (item, index) => {
                                                        return (
                                                            <li key={index}><a href={`/education/${item.slug}`} >{item.title}</a></li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        : '' }
		                        	</li>
		                        	<li>
		                        	    <a href="/jobs">Jobs</a>
		                        		<ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
		                        		    <li><a href="/jobs">Search</a></li>
		                        			<li><a href="/jobs/industries">Industries</a></li>
		                        			<li><a href="/jobs/hire-writers">Hire Writers</a></li>
		                        		</ul>
		                        	</li>

		                        	<li>
		                        	    <a href="/library/articles">Library</a>
		                        		<ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
		                        		    <li><a href="/library/articles">Articles</a></li>
		                        		    <li><a href="/library/guides">Guides</a></li>
		                        		    <li><a href="/library/resources">Resources</a></li>
                                            {this.state.wpLibraryPages && this.state.wpLibraryPages.length >= 1 &&
                                            this.state.wpLibraryPages.map(
                                                (item, index) => (
                                                    <li key={index}>
                                                        <a
                                                            href={`/library/free/${item.page_slug}`}
                                                        >
                                                            {
                                                                item.page_name
                                                            }
                                                        </a>
                                                    </li>
                                                )
                                            )}
		                        		</ul>
		                        	</li>
		                        	<li>
		                        	    <a href="/tools/portfolios">Tools</a>
		                        		<ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
		                        		    <li><a href="/tools/portfolios">Portfolios</a></li>
		                        		    <li><a href="/tools/submissions">Submissions</a></li>
                                            {this.state.wpToolsPages && this.state.wpToolsPages.length >= 1 &&
                                            this.state.wpToolsPages.map(
                                                (item, index) => (
                                                    <li key={index}>
                                                        <a
                                                            href={`/tools/free/${item.page_slug}`}
                                                        >
                                                            {
                                                                item.page_name
                                                            }
                                                        </a>
                                                    </li>
                                                )
                                            )}
		                        		</ul>
		                        	</li>
		                        </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                </header>

            </Fragment>
        );
    }
}
Header.contextType = AppContext;

export default withRouter(({ location, ...props }) => {
    return <Header {...props}   />;
 });



// WEBPACK FOOTER //
// ./src/components/employer/account/Header.js